import { render, staticRenderFns } from "./Beds.vue?vue&type=template&id=50a71050&scoped=true&"
import script from "./Beds.vue?vue&type=script&lang=js&"
export * from "./Beds.vue?vue&type=script&lang=js&"
import style0 from "./Beds.vue?vue&type=style&index=0&id=50a71050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a71050",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VTextField})
